import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

// ----------------------------------------------------------------------

export default function EmptyContent({ title, img, action, description, filled, sx, ...other }) {
    return (
        <Stack
            flexGrow={1}
            alignItems="center"
            justifyContent="center"
            sx={{
                px: 3,
                height: 1,
                ...(filled && {
                    borderRadius: 2,
                    bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
                    border: (theme) => `dashed 1px ${alpha(theme.palette.grey[500], 0.08)}`,
                }),
                ...sx,
            }}
            {...other}
        >
            <Box
                component="img"
                alt="empty content"
                src={img || '/assets/illustrations/illustration_empty_content.svg'}
                sx={{ width: 1, maxWidth: 160, mb: 3 }}
            />

            {title && (
                <Typography variant="h6" component="span" sx={{ color: 'text.secondary' }}>
                    {title}
                </Typography>
            )}

            {description && (
                <Typography variant="caption" sx={{ color: 'text.secondary', mt: 1 }}>
                    {description}
                </Typography>
            )}

            {action && action}
        </Stack>
    );
}

EmptyContent.propTypes = {
    action: PropTypes.node,
    description: PropTypes.string,
    filled: PropTypes.bool,
    img: PropTypes.string,
    sx: PropTypes.object,
    title: PropTypes.string,
};
